

//                                          BİSMİLLAHİRRAHMANİRRAHİM
//                                              ALLAHU EKBER
//                                              ELHAMDÜLİLLAH

import map from '../../src/images/map.svg'
import blog from '../../src/images/blog.svg'
import message from '../../src/images/message.svg'


export const Turkish = {
    Navbar : {
        Logo : 'Yeniçeri',
        Links : ['Hakkımda', 'Geliştirici', 'Web Güvenlikçisi', 'Tasarımcı', 'Projeler'],
        LinkHelpers : ['hakkimda', 'gelistirici', 'web', 'tasarimci', 'projeler'],
        Buttons : ['Mail at'],
        ButtonHelper : ['mesajat']
    },

    HeroSection : {
        H1 : 'Haydi Bismillah!',
        P : 'Yusuf\'un sitesine hoşgeldin.',
        Button : 'Devam et'
    },

    InfoSection : [
        {
            topLine: 'Hakkımda',
            headline: 'Ben kimim?',
            description : 'Elbette ki Allah \'ın bir kulu!',
            buttonLabel : 'Devam et'
        },
        {
            topLine: 'GELİŞTİRİCİ',
            headline: 'Neler yaparım?',
            description : 'Web, mobile ve masaüstü uygulamalar yazarım inşaAllah.',
            buttonLabel : 'Devam et'
        },
        {
            topLine: 'Web GÜVENLİKÇİSİ',
            headline: 'Ney? Güvenlikçi mi?',
            description : 'Daha güvenli ürünler yapmak üzere, Web Güvenliği üzerine çalıştım.',
            buttonLabel : 'Devam et'
        },
        {
            topLine: 'Tasarımcı',
            headline: 'Kullanıcı için yazılım, arayüz demektir!',
            description : 'Çeşitli tasarımları incelemeye çalışırım.',
            buttonLabel : 'Devam et'
        }
    ],

    Services:
    {
        'main' : 'Projeler',
        'others':
                    [
                        {
                            Icon : blog,
                            H2 : '.NET MVC de Blog',
                            P : 'Kişisel Blog Sitesi'
                        },
                        {
                            Icon : map,
                            H2 : 'Personel Yönetim Sistemi',
                            P : 'Şirket içerisinde Personellerin yönetimini kolaylaştıran bir websitesi'
                        },
                        {
                            Icon : message,
                            H2 : 'Programcıların Sohbet Yeri',
                            P : 'Programcıları bir araya getirmek için yapılmış olan bir website'
                        },
                    ],
        'github' : 'Daha fazlası için ..'
    },
    Footer:{
        Title: 'Gidebileceğiniz Yerler',
        rights: 'Tüm hakları saklıdır.'
    }
}

export const English = {
    Navbar : {
        Logo : 'Yeniçeri',
        Links : ['About me', 'Developer', 'Web Security Guard', 'Designer', 'Projects'],
        LinkHelpers : ['hakkimda', 'gelistirici', 'web', 'tasarimci', 'projeler'],
        Buttons : ['Send Mail'],
        ButtonHelper : ['mesajat']
    },

    HeroSection : {
        H1 : 'Hi! I am Yusuf',
        P : 'Welcome to my website.',
        Button : 'Continue'
    },

    InfoSection : [
        {
            topLine: 'About me',
            headline: 'Who am I?',
            description : 'Of course a servant of Allah!',
            buttonLabel : 'Continue'
        },
        {
            topLine: 'Developer',
            headline: 'What do I do?',
            description : 'I write web, mobile and desktop applications, insha\'Allah.',
            buttonLabel : 'Continue'
        },
        {
            topLine: 'Web Security Guard',
            headline: 'What? The Web Security Guard?',
            description : 'I worked on Web Security to make safer products.',
            buttonLabel : 'Continue'
        },
        {
            topLine: 'Designer',
            headline: 'For the user, software means interface!',
            description : 'I try to examine various designs.',
            buttonLabel : 'Continue'
        }
    ],

    Services:
    {
        'main' : 'Projects',
        'others':
                    [
                        {
                            Icon : blog,
                            H2 : 'Blog in .NET MVC',
                            P : 'Personel Blog Site'
                        },
                        {
                            Icon : map,
                            H2 : 'Personnel Management System',
                            P : 'A website that facilitates the management of the personnel within the company'
                        },
                        {
                            Icon : message,
                            H2 : 'Chatting Place of Programmers',
                            P : 'It is a website to unite all programmers'
                        },
                    ],
        'github' : 'For more ..'
    },
    Footer:{
        Title: 'Go To',
        rights: 'All rights reserved.'
    }
}